import { Outlet, NavLink } from 'react-router-dom';
import { useCart } from '../contexts/CartContext';
import { useAuth } from '../contexts/AuthContext';
import { useState, useEffect } from 'react';
import { getConfiguracoesPublico } from '../services/api';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function Layout() {
  const { totalItems } = useCart();
  const { user } = useAuth();
  const [config, setConfig] = useState({ nome_lanchonete: 'Empório Paco', logo_url: null });

  useEffect(() => {
    getConfiguracoesPublico().then(r => setConfig(r.data)).catch(() => {});
  }, []);

  return (
    <div style={{ maxWidth: 480, margin: '0 auto', minHeight: '100vh', background: 'var(--bg)' }}>
      {/* TOPBAR */}
      <nav style={{
        background: 'var(--bg2)', borderBottom: '1px solid var(--border)',
        padding: '0 16px', height: 56,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        position: 'sticky', top: 0, zIndex: 100
      }}>
        <NavLink to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 8 }}>
          {config.logo_url ? (
            <img src={`${API_URL}${config.logo_url}`} alt="Logo"
              style={{ height: 44, width: 'auto', maxWidth: 160, objectFit: 'contain' }} />
          ) : (
            <span style={{
              fontFamily: "'Bebas Neue', sans-serif", fontSize: 18,
              background: 'linear-gradient(90deg,var(--red),var(--orange))',
              WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent'
            }}>{config.nome_lanchonete || 'Empório Paco'}</span>
          )}
        </NavLink>

        {user ? (
          <NavLink to="/fidelidade" style={{ textDecoration: 'none' }}>
            <span style={{
              background: 'linear-gradient(90deg,var(--orange),var(--red))',
              padding: '5px 12px', borderRadius: 20, fontSize: 12, fontWeight: 700, color: '#fff'
            }}>⭐ {user.pontos || 0} pts</span>
          </NavLink>
        ) : (
          <NavLink to="/login" style={{
            textDecoration: 'none', border: '1px solid var(--border)',
            color: 'var(--text2)', padding: '5px 12px', borderRadius: 20, fontSize: 12, fontWeight: 700
          }}>Entrar</NavLink>
        )}
      </nav>

      {/* AVISO LOJA FECHADA */}
      {config.aberto === '0' && (
        <div style={{
          background: 'linear-gradient(135deg, #c92020, #8a0000)',
          color: '#fff',
          padding: '12px 16px',
          textAlign: 'center',
          fontSize: 13,
          fontWeight: 700,
          fontFamily: 'Nunito, sans-serif',
          borderBottom: '2px solid #5a0000',
          position: 'sticky',
          top: 56,
          zIndex: 99,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 8,
          animation: 'pulseFechado 2.5s ease-in-out infinite'
        }}>
          <span style={{ fontSize: 18 }}>🔴</span>
          <span>{config.mensagem_fechado || 'Loja fechada no momento. Volte em breve!'}</span>
        </div>
      )}
      <style>{`
        @keyframes pulseFechado {
          0%, 100% { opacity: 1; }
          50% { opacity: .85; }
        }
      `}</style>

      {/* CONTENT */}
      <main style={{ paddingBottom: 70 }}>
        <Outlet />
      </main>

      {/* BOTTOM NAV */}
      <nav style={{
        position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)',
        width: '100%', maxWidth: 480,
        background: 'var(--bg2)', borderTop: '1px solid var(--border)',
        display: 'flex', height: 60, zIndex: 100
      }}>
        {[
          { to: '/', icon: '🏠', label: 'Início', end: true },
          { to: '/cardapio', icon: '🍔', label: 'Cardápio' },
          { to: '/carrinho', icon: '🛒', label: 'Carrinho', badge: totalItems },
          { to: '/pedidos', icon: '📦', label: 'Pedidos' },
          { to: '/perfil', icon: '👤', label: 'Perfil' },
        ].map(item => (
          <NavLink key={item.to} to={item.to} end={item.end} style={({ isActive }) => ({
            flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center',
            justifyContent: 'center', gap: 2, textDecoration: 'none',
            color: isActive ? 'var(--orange)' : 'var(--text3)',
            fontSize: 9, fontWeight: 700, fontFamily: 'Nunito, sans-serif',
            borderTop: isActive ? '2px solid var(--orange)' : '2px solid transparent',
            position: 'relative'
          })}>
            <span style={{ fontSize: 20 }}>{item.icon}</span>
            {item.label}
            {item.badge > 0 && (
              <span style={{
                position: 'absolute', top: 4, right: '22%',
                background: 'var(--red)', color: '#fff',
                borderRadius: '50%', width: 16, height: 16,
                fontSize: 9, fontWeight: 800,
                display: 'flex', alignItems: 'center', justifyContent: 'center'
              }}>{item.badge}</span>
            )}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
